import React from 'react';
import { Menu, Image, Container, Input, Button, Modal, Header, Icon } from 'semantic-ui-react'

class AppHeader extends React.Component {
  constructor(props) {
    super(props);
    this.onSearchChange = props.onSearchChange;

    this.handleClick = this.handleClick.bind(this);
  }

  
  onSearchChange = null;
  state = {
    value: '',
    onlyCurrent: false,
    modalOpen: false
  };

  handleChange = (event) => {
    this.setState({ value: event.target.value });
    this.onSearchChange({searchTerm: event.target.value, 
      onlyCurrent: this.state.onlyCurrent});
  }

  handleClick = () => {
    this.setState({ onlyCurrent: !this.state.onlyCurrent });
    this.onSearchChange({searchTerm: this.state.value, 
      onlyCurrent: !this.state.onlyCurrent});
  }

  handleOpen = () => this.setState({ modalOpen: true })

  handleClose = () => this.setState({ modalOpen: false })

  render() {

    let iconDirectory = '/';
    if (window.location.hostname.indexOf("github.io") !== -1) {
      iconDirectory = '/fresh-calendar-web/';
    }
    //const { name } = this.props;
    return (
      <Menu fixed='top' stackable>
      <Container>
        <Menu.Item as='a' header>
          <Image size='mini' src={ iconDirectory + 'icon.svg'} style={{ marginRight: '1.5em' }} />
          Kalendarz sezonowy
        </Menu.Item>
        <Menu.Item wide="true" style={{flexGrow:1}}>
          <Input icon='search' placeholder='Wyszukaj...'
                 value={this.state.value} onChange={this.handleChange}
                  />
        </Menu.Item>
        <Menu.Item>
          <Button toggle active={this.state.onlyCurrent} onClick={this.handleClick}
          style={{marginRight: "5px"}}>
                    Tylko aktualnie dostępne
          </Button>
          <Modal trigger={<Button onClick={this.handleOpen}>?</Button>} size='small'
            open={this.state.modalOpen}
            onClose={this.handleClose}>
            <Header icon='archive' content='Informacje' />
            <Modal.Content>
              {/* <h4>Kontakt:</h4>
              <p>
                Wszelkie pytanie lub sugestie prosze przyłać mailowo: <a href="mailto:aa@aa.pl">...</a>
              </p> */}

              <p>
                Grafiki pochodzą z:
              </p>
              <ul>
                <li><a href="https://www.flaticon.com/">FlatIcon</a></li>
                <li><a href="https://thenounproject.com/">Noun Project</a></li>
              </ul>
            </Modal.Content>
            <Modal.Actions>
              <Button color='green' onClick={this.handleClose}>
                <Icon name='checkmark' /> Ok
              </Button>
            </Modal.Actions>
          </Modal>
        </Menu.Item>
      </Container>
</Menu>
    );
  }
}

export default AppHeader;